import { type BreadcrumbTrailItem, buildBreadcrumbList, isRenderableBreadcrumbTrail, JsonLd } from '@benzinga/seo';

interface BreadcrumbSchemaProps {
  items: BreadcrumbTrailItem[];
}

export const BreadcrumbSchema = ({ items }: BreadcrumbSchemaProps) => {
  if (!isRenderableBreadcrumbTrail(items)) return null;

  return <JsonLd data={buildBreadcrumbList(items)} id="gov-trades-breadcrumb-schema" />;
};
